import axios from "axios";

const api = axios.create({
    baseURL: 'https://airmont.dev.jlconsulting.fr/api'
  });



export default api;